<template>

<div class="input textbox" :data-theme="theme">

    <input 
		:name="name" 
		type="text" 
		:placeholder="placeholder" 
		v-bind:value="value" 
		v-on:input="$emit('input', $event.target.value)" 
		class="textbox-input" 
		autocomplete="off" 
		autocorrect="off" 
		autocapitalize="off" 
		spellcheck="false"
		v-on:focus="$emit('focus')" 
		v-on:blue="$emit('blur')"
	/>

</div>

</template>

<script>

export default {

	props: [
		'name', 'theme', 'value', 'placeholder'
	]

}

</script>

<style scoped>

.textbox-input {
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    padding: 0px 10px;
    font-size: 14px;
    color: #fff;
	font-weight: 400;
    width: 100%;
    background-color: #3c6981;
}

.is-mobile .textbox-input {
	background-color: #f7f7f7;
	color: #343434;
}

.textbox-input::placeholder {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
}

.is-mobile .textbox-input::placeholder {
	color: #999;
}

.textbox-input:focus {
    background-color: #487994;
}

.is-mobile .textbox-input:focus {
    background-color: #eee;
}

</style>
